// -------request start -------

import { ServiceFloorData } from '@/components/product/interface';

export const PROMOTION_KEY = 'HJM-P#canSelectPromotionPart&canSelectPromotion';
export const SUB_TOTAL_DETAIL_KEY = 'core.trade-DM#cartView.subtotalDetail-M#subtotalDetailItem'; // 价格明细楼层key
export const REMOVE_KEY = 'core.trade-DM#cartView.unusableProduct-M#defaultUnusableProductItem'; // 下架商品楼层key
export const PRODUCT_ITEM_CORE_KEY = 'C-M#productItem&core';
export const PRODUCT_ITEM_BASIC_KEY = 'C-M#productItem&basic';
export const PRODUCT_ITEM_EXTINFO_KEY = 'HJM-M#cartProduct&extInfo';
export const COUPON_DETAIL_KEY = 'core.trade-DM#cartView.coupon-M#defaultCouponItem'; // 优惠券明细楼层key
export const TAB_MENU_ITEM_KEY = 'core.trade-DM#cartView.tabMenu-M#tabMenuItem'; // tab配送方式楼层key
export const PRODUCT_ITEM_STOCK_INFO_KEY = 'HJM-M#cartProduct&stockInfo'; // 有货的商品key
export const PRODUCT_KEY = 'core.trade-DM#cartView.product-M#productItem'; // 商品 namespace key
export const PRODUCT_PRICE_INFO_KEY = 'HJM-M#cartProduct&priceInfo'; // 商品价格信息key
export const SUBTOTAL_DETAIL_ITEM_CORE_KEY = 'C-M#subtotalDetailItem&core';
export const COMPONENT_INFO_KEY = 'HJM-M#cartProduct&componentInfo'; // 组件显示状态楼层key
export const SERVICE_KEY = 'core.trade-DM#cartView.product-M#serviceItem'; // 服务品楼层key
// v830 赠品
export const GIFT_POOL_COL_NAMESPACE_KEY = 'core.trade-DM#cartView.group-M#giftPoolCollection'; // 赠品聚合抽屉 namespace key
export const GIFT_POOL_ITEM_BASIC_KEY = 'HJM-M#giftPoolCollection&basic'; // 赠品key
export const GIFT_ITEM_KEY = 'core.trade-DM#cartView.product-M#giftItem'; // 赠品楼层key
export const GIFT_COLLECTION_KEY = 'core.trade-DM#cartView.group-M#giftCollectionGroup'; // 顶部赠品楼层key
export const GIFT_EXT_INFO_KEY = 'HJM-M#cartGiftCollection&extInfo'; // 顶部赠品楼层信息扩展key
export const GIFT_SUB_DRAWER_KEY = 'core.trade-DM#cartView.product-M#giftSubCollectionItem'; // 赠品聚合父组件key
export const GIFT_CHECK_RESULT_ITEM_KEY = 'core.trade-DM#cartView.group-M#giftCheckResultItem'; // 结算是否缺货or赠品未选key
export const GIFT_INFO_KEY = 'HJM-M#cartProduct&giftInfo'; // 赠品信息key
export const GIFT_GROUP_BASIC_KEY = 'HJM-M#groupModel&basic'; // 去结算是否弹窗信息
export const GIFT_SNACKBAR_KEY = 'HJM-M#cartGiftCollection&banner'; // 赠品礼物通知条信息
// ------- 点击结算 -------
export const GIFT_CHECKOUT_RESULT_KEY = 'core.trade-DM#cartView.group-M#checkoutGiftResultGroup'; // 点击checkout查询赠品楼层key
export const GIFT_CHECKOUT_ITEM_KEY = 'core.trade-DM#cartView.promotionGifts-M#giftCheckResultItem'; // 点击checkout查询item key
export const GIFT_CHECKOUT_KEY = 'HJM-M#giftCheckout&basic'; // 点击checkout查询赠品失效弹窗信息
export const GIFT_CHECKOUT_BASIC_KEY = 'HJM-M#giftCheckResult&basic'; // 点击checkout查询赠品失效弹窗信息扩展key
export const GIFT_CHECKOUT_EXT_INFO_KEY = 'HJM-M#giftCheckResult&extInfo'; // 击checkout查询主品与赠品信息
// 赠品聚合弹层信息
export const GIFT_BASIC_KEY = 'HJM-M#cartGiftCollection&basic'; // 顶部赠品楼层信息
export const GIFT_SUB_COL_EXT_INFO = 'HJM-M#cartGiftSubCollection&extInfo';
export const GIFT_PROMO_INFO_KEY = 'HJM-M#cartGiftSubCollection&promoInfo'; // 赠品抽屉中赠品信息
export const GIFT_SUB_COL_BASIC = 'HJM-M#cartGiftSubCollection&basic'; // 赠品组抽屉中赠品信息
export const GIFT_SUB_COL_NAMESPACE_KEY =
  'core.trade-DM#cartView.promotionGifts-M#giftSubCollectionItem'; //赠品聚合弹窗namespace

export const VIEW_SEL_ITEM_KEY = 'C-M#viewSelectedItem&core'; // 选中商品信息
export const VIEW_SEL_ITEM_PRICE_INFO = 'C-M#priceViewItem&priceInfo'; // 价格信息

export enum MenuTabType {
  'TAB_64' = '64',
  'TAB_66' = '66',
}
export enum ShipmentType {
  'DELIVERY' = '66',
  'PICKUP' = '64',
}

export enum LimitInfoType {
  'AREA_LIMIT' = 'areaLimit',
}

export enum DeliveryGroupEnum {
  GLOBAL = 'default_group_delivery_global', // 全球配送
  PICKUP_ONLY = 'default_group_pickup_only', // 仅自提
  LOCAL = 'default_group_delivery_local', // 本地配送
  PICKUP_STANDARD = 'default_group_pickup_standard', // 标准自提
  DELIVERY_ONLY = 'default_group_delivery_only', // 仅配送
}

export enum CartItemType {
  SUBTOTAL = '1', // 小计项目
  DISCOUNT = '2', // 折扣项目
  TOTAL = '6', // 总计项目
  DELIVERY = '7', // 配送项目
  MEMBER_DISCOUNT = '8', // 会员折扣项目
}

export interface BodyParam {
  area?: string;
  refer?: number;
  client?: string;
  clientVersion?: string;
  userActionId?: string;
  verticalTag?: string;
  omittedDetail?: boolean;
  longitude?: string;
  latitude?: string;
  languageCode?: string;
  countryCode?: string;
  scene?: number;
  businessOrigin?: string;
  cartuuid?: string;
  extendParamMap?: {
    stock: boolean;
    tabId?: string;
  };
  operations?: Operations;
  skuId?: string;
  updateTags?: any;
  shipmentType?: string; //配送方式 66 配送 or 64 自提
  serviceItemIds?: string[]; // 服务项ID列表
  requestSource?: number; // 1 代表需要查下赠品相关信息
}

export interface GetCartRequest {
  client?: string;
  clientVersion?: string;
  area?: string;
  body?: string;
  t?: number;
  appid?: string;
  bodyQuery?: any;
}

export interface OperationProduct {
  skuId?: string;
  num?: string;
  itemType?: number;
  id?: string;
  parentId?: string;
  skuUuid?: string; // 商品的唯一标识
  addonProducts?: any[];
  childList?: string[]; // 赠品uuidv4
  selectState?: number;
}

export interface OperationPromotion {
  num?: string;
  childList?: string[];
  id?: string;
  promotionId?: string;
  itemType?: string;
}

export interface Operations {
  products: OperationProduct[];
  promotions?: OperationPromotion[];
  updateTags?: any;
  selectedGiftProducts?: any[];
}

export interface GetFloorRequest {
  floorId: string;
  skuId: string;
  serviceItemIds?: string[];
  scene?: string;
}
//  ------- request end -------

// ----- response start ---------
export interface CartType {
  namespace: string;
  version: string;
}

export interface TabMenuItemInfo {
  'C-M#tabMenuItem&core': {
    tabId: string;
    tabName: string;
    tabType: string;
    selected?: boolean;
  };
}

interface ProductItemBasicInfo {
  skuName: string;
  imgUrl: string;
  thirdCId?: string;
  price?: string;
  firstCid?: string;
  num: string;
  activeCheck: number;
  secondCid?: string;
  isSetDefaultValue?: boolean;
  crossPriceText?: string;
}

export interface MarkInfo {
  icon: string;
  text: string;
  type: number;
  richText: string;
  textColor: string;
  bgColor: string;
}

export enum NumComponentType {
  'NOT_SHOW' = 1,
  'SHOW' = 2,
  'DISABLED' = 3,
  'NOTIFY' = 4,
}

export enum DeleteComponentType {
  'NOT_SHOW' = 1,
  'SHOW' = 2,
}

export interface ComponentInfo {
  numComponentType: number; // 数量控制组件状态，1是不展示，2是正常，3是置灰，4是 notify（老的notify逻辑不变）
  delComponentType: number; // delete 按钮组件控制，1不显示，2显示delete 后续这个位置可以增加更多
}

export interface CartProductExtInfo {
  enableCheck: number;
  productMarkInfo: {
    [key: string]: string;
  };
  itemType: number;
  totalPromoPrice: string;
  discount: string;
  maxBuyNum: string;
  revertPrice: string;
  donateSku: boolean;
  iconMap: {};
  specialId: string;
  includeCheckAll: boolean;
  originPriceShow: string;
  subtotalPrice: string;
  landedPrice: string;
  addCartTime: number;
  tabIdList: string[];
  limitBuy: boolean;
  skuUuid?: string;
  accountType: string;
  provideServiceFlag: number;
  rePrice: string;
  priceShow: string;
  productMarkSet: string[];
  weightDesc: string;
  cardSpecialId: number;
  propertyTagMap: {
    [key: string]: string;
  };
  brandId: string;
  currency: string;
  tagImgIconUrlList?: string[]; // 图标url 雪花标、飞机标等
  supportedShipmentType?: string[]; // 该商品包含：配送和自提
  checkType: 0 | 1; // 0未勾选，1选中
  priceMsg: string;
  priceRichTextMsg: string;
  isAvailable: boolean;
  containServiceFlag?: number; // 是否包含服务项 0：不包含 1：包含
  activityList?: number[]; //商品活动列表 1.新人价 2.预售  v815
  noStockSubscribeNotifyStatus?: number; // 0未订阅，1已订阅
  unitShowG11N?: string; // 商品合规单位
  landedPriceText?: string;
  freeText?: string; // 0元单文案
  preSellText?: string; // 促销价格
  limitBuyInfo?: {
    limitBuyTag: string; // 'areaLimit' 代表命中了本次规则
    limitTagIcon: string;
    limitDesc: string;
    limitRuleDesc: string; // 弹窗多源文案
    skuNumberChange: string; // 代表增加购物车时候，sku变了，需要toast提示
  };
}

export enum ActivityListEnum {
  NEW_PRICE = 1, // 新人价
  PRE_SALE = 2, // 预售
  PRE_SELL = 3, // 预约
}
interface ProductStockCoreInfo {
  remainNum: number;
  stockType: number;
  stockCodeDesc: string;
  stockCode: number;
}

interface ProductItemCoreInfo {
  skuId: string;
}

interface AbstractUnusableProductItemBasic {
  skuName: string;
  unusableType: string;
  imgUrl: string;
  itemType: number;
  price: string;
  num: string;
}

interface UnusableProductModelPropertyTag {
  color: string;
  size: string;
}

interface UnusableProductModelBasic {
  skuUuid: string;
  thirdCId: string;
  firstCid: string;
  weight: string;
  secondCid: string;
  propertyTag: UnusableProductModelPropertyTag;
}

interface AbstractUnusableProductItemCore {
  skuId: string;
}

export interface SubtotalDetailItemCore {
  adjustType: string;
  price: string;
  subItemName: string;
  name: string;
  type: string;
  seq: number;
}

export type CartProductItem = {
  info: ProductItemInfo;
  services?: ProductItem[];
  gifts?: ProductItem[];
  giftInfo?: CartPromotionGiftPromoInfo;
};

export interface ProductPriceInfo {
  color: string;
  size: string;
  price: string;
  weight: string;
  curSymSize: string;
  textShow: string;
}

export type ProductItem = {
  info: ProductItemInfo;
};

export interface ProductItemInfo {
  partList?: PartList[];
  [PRODUCT_ITEM_BASIC_KEY]?: ProductItemBasicInfo;
  [PRODUCT_ITEM_EXTINFO_KEY]?: CartProductExtInfo;
  [PRODUCT_ITEM_CORE_KEY]?: ProductItemCoreInfo;
  [PRODUCT_ITEM_STOCK_INFO_KEY]?: ProductStockCoreInfo;
  'C-M#abstractUnusableProductItem&basic'?: AbstractUnusableProductItemBasic;
  'HJM-M#unusableProductModel&basic'?: UnusableProductModelBasic;
  'C-M#abstractUnusableProductItem&core'?: AbstractUnusableProductItemCore;
  'HJM-M#cartProduct&componentInfo'?: ComponentInfo; // 组件显示与隐藏状态信息
  [PRODUCT_PRICE_INFO_KEY]?: ProductPriceInfo;
  [GIFT_INFO_KEY]?: ProductItemGiftInfo; // 赠品底部卡片info/赠品信息
  [GIFT_BASIC_KEY]?: PromotionGiftBasic;
  [GIFT_EXT_INFO_KEY]?: CartPromotionGiftExtInfo;
  [GIFT_GROUP_BASIC_KEY]?: GroupModelBasic;
  [GIFT_PROMO_INFO_KEY]?: CartPromotionGiftPromoInfo; // 赠品抽屉中赠品信息
  [GIFT_CHECKOUT_BASIC_KEY]?: GiftCheckResultBasic;
}

// 主品下挂的赠品卡片标题相关信息
export interface ProductItemGiftInfo {
  giftMaxCnt?: number; // 最大赠品数量
  title?: string;
  selectButtonText?: string;
  selectType?: number;
  promotionId?: number;
  promotionItemType?: number;
  itemType?: number;
  promotionType?: number;
  isValid?: boolean; // false 代表失效 包含下架、无货
}

export interface CartGiftCollectionData {
  [GIFT_BASIC_KEY]: CartGiftCollection;
  [GIFT_EXT_INFO_KEY]: CartGiftCollectionExtInfo;
  [GIFT_SNACKBAR_KEY]?: SnackbarBanner; // 赠品礼物通知条信息
}

export interface SnackbarBanner {
  bannerType: number; // banner文案类型 1 select， 2 view
  bannerImgUrl: string[]; // url数组
  bannerText: string; // "You can select 2 free samples now!" | "Congrats, You have **"
  bannerActionText: string; // select
  bannerPcTitle: string; // "Congrats",
}

export interface CartGiftCollection {
  title: string;
  selectedNum: number;
  canSelectMaxNum: number;
  showTitle: string; // "Selected samples (2/5)"
  cornerSelectButtonText: string; // "Select more x gifts" | "Reselect" | ""
  bannerText: string; // "You can select 2 free samples now!" | "Congrats, You have **"
  bannerType: number; // banner文案类型 1 select， 2 view
  bannerActionText: string; // "select"
}

export interface CartGiftCollectionExtInfo {
  showGiftItemList: string[]; // 每个都是一个赠品商品
  selectButtonText: string; // "Select x free samples"
  subCollectionTitle: string; // "Free sample"
  subCollectionList: string[]; // 每个都是子赠品楼层，排好序的
}
// 主品下挂的赠品卡片标题相关信息
export interface GiftInfo {
  title: string; // 礼品标题
  selectButtonText: string; // 按钮文本 'Select' | 'Reselect' |
  selectType: number; // 选择类型
  promotionId: number; // 促销 ID
  giftMaxCnt: number; // 最大礼品数量
  promotionItemType: number; // 促销物品类型
}

export interface GroupModelBasic {
  promotionId: number; // 促销ID
  selectType: number; // 选择类型，1 或 2
  giftMaxCnt: number; // 最大赠品数量
  promotonItemType: number; // 促销商品类型
}

export interface CartPromotionGiftPromoInfo {
  promotionId: number; // 促销ID
  giftMaxCnt: number; // 最大赠品数量
  giftCurrentCnt: number; // 当前赠品数量
  promotionItemType: number; // 促销商品类型
  selectType: number; // 选择类型
  itemType?: number;
  promotionType?: number;
  giftSelectedCnt?: number; // 已选择赠品数量
  giftSelectFull?: boolean; // 是否已选满
}

// 赠品选择抽屉
export interface GiftDrawerInfo {
  [GIFT_POOL_ITEM_BASIC_KEY]: {
    promoMidTitle: string;
    promoTitle: string;
    promoEndTime: string;
    promoExplain: string;
    itemType: number;
    promotionId: number;
    giftMaxCnt: number;
  };
}

export interface GiftCheckResult {
  [GIFT_CHECKOUT_BASIC_KEY]: GiftCheckResultBasic;
  [GIFT_CHECKOUT_EXT_INFO_KEY]: GiftCheckResultExtInfo;
}

export interface GiftCheckResultExtInfo {
  mainProductItemList: string[]; // 每个都是一个主品商品
  invalidGiftItemList: string[]; // 每个都是失效赠品商品
}
export interface CartPromotionGiftExtInfo {
  showGiftItemList: string[]; // 每个都是一个赠品商品
  selectButtonText: string; // "Select x free samples"
  subCollectionTitle: string; // "Free sample"
  subCollectionList: string[]; // 每个都是子赠品楼层，排好序的
}

// 赠品信息
export interface GiftItem {
  [PRODUCT_ITEM_BASIC_KEY]?: {
    skuName: string;
    imgUrl: string;
    num: string;
    activeCheck: number;
    crossPriceText: string;
    preSellText?: string;
  };
  [PRODUCT_ITEM_EXTINFO_KEY]?: {
    discount: string;
    isAvailable: boolean;
    landedPriceText: string;
    freeText: string;
    priceRichTextMsg: string;
    itemType: number;
    addCartTime: number;
    preSellText?: string;
    skuUuid: string;
  };
  [PRODUCT_ITEM_CORE_KEY]?: { skuId: string };
}

// 赠品选择抽屉中赠品---
export interface GiftDrawerItem {
  info: {
    [PRODUCT_ITEM_BASIC_KEY]: {
      skuName: string;
      imgUrl: string;
      num: string;
      activeCheck: number;
    };
    [PRODUCT_ITEM_EXTINFO_KEY]: {
      enableCheck: number;
      itemType: number;
    };
    [PRODUCT_ITEM_STOCK_INFO_KEY]: {
      remainNum: number;
    };
    [PRODUCT_ITEM_CORE_KEY]: {
      skuId: string;
    };
  };
}

// ----赠品UI---
export interface CartGiftDrawerInfo {
  subCollectionTitle: string;
  gifGroupDrawerFloor: GifGroupDrawerFloor[];
}
export interface GifGroupDrawerFloor {
  info: GiftFloorItemInfo;
  invalidGiftItemList: ProductItem[];
  mainProductItemList: ProductItem[];
  giftItemList: ProductItem[];
}
// 赠品选择抽屉中单个赠品组，自行组装
export interface SingleGiftGroup {
  giftInfo: GiftDrawerInfo;
  mainSKUs: ProductItem[];
  gifts: ProductItem[];
}

// 聚合赠品抽屉中赠品信息
export interface GiftFloorItemInfo {
  [GIFT_PROMO_INFO_KEY]?: CartPromotionGiftPromoInfo; // 赠品抽屉中赠品信息
  [GIFT_SUB_COL_EXT_INFO]: CartPromotionGiftFloorInfo; // 赠品聚合楼层信息
  [GIFT_SUB_COL_BASIC]?: { title: string; cornerSelectButtonText?: string };
}

// 失效信息
export interface GiftFailedItemInfo {
  [GIFT_CHECKOUT_BASIC_KEY]?: CartPromotionGiftPromoInfo;
  [GIFT_CHECKOUT_EXT_INFO_KEY]: CartPromotionGiftFloorInfo;
}

export interface CartPromotionGiftFloorInfo {
  mainProductItemList: string[]; // 主品商品列表
  explainText: string; // "With these items purchased, you can select up to x free samples"
  selectButtonText: string; //  'Select x free samples';
  giftItemList: string[];
  giftImgUrlList: string[];
  invalidGiftItemList: string[];
  cornerSelectButtonText?: string; // "Reselect" | ""
}

export interface GiftCheckoutBasic {
  giftExistInvalid: boolean; // false 不存在 true 存在
  giftExistUnselectSample: boolean; // false 不存在 true 存在
  giftInvalidPopupTitle: string; // 弹窗标题
  giftInvalidPopupExplain: string; // 弹窗说明
}

export interface GiftCheckoutTitleBasic {
  [GIFT_CHECKOUT_KEY]: GiftCheckoutBasic;
}

export interface GiftCheckResultBasic {
  promotionId: number;
  selectType: number; // 1 或 2
  giftMaxCnt: number;
  itemType: number; // 商品类型
  promotionType: number; // 促销类型
}

// 赠品聚合楼层（赠小样）
export interface GiftCollectionItem {
  info: {
    [GIFT_SUB_COL_EXT_INFO]: {
      mainProductitemList: string[];
      explainText: string; // "With these items purchased, you can select up to x free samples"
      selectButtionText: string; //  'Select x free samples';
      giftItemList: string[];
    };
    [GIFT_BASIC_KEY]: { title: string; CornerSelectButtonText: string };
  };
}
export interface PromotionGiftBasic {
  title: string;
  selectedNum: number;
  canSelectMaxNum: number;
  showTitle: string; // "Selected samples (2/5)"
  cornerSelectButtonText: string; // "Select more x gifts" | "Reselect" | ""
  bannerText: string; // "You can select 2 free samples now!" | "Congrats, You have **"
}

export interface FreightBasicInfo {
  'HJM-M#basic&basic': {
    coudanTabsG11N: string;
    displayType: number;
    coudanMsgRichTextG11N: string;
    coudanMsgG11N: string;
    totalPriceNeed: string;
    freePostThreshold: string;
    isFreeFreight: boolean;
  };
}

export interface AddCartStatusInfo {
  'HJM-M#basic&basic': {
    checkNoStockSkuList: string;
    displayType: number;
  };
}

export interface OfficialDocInfo {
  'C-M#officialDoc&popUpWindow': {
    windowText: string;
    shouldShowPopUp: number;
  };
}

export interface TitleDescriptionInfo {
  'HJM-M#groupModel&feeDescription': {
    feeThresholdRichTextG11N: string;
    feeThresholdTextG11N: string;
  };
  'HJM-M#groupModel&speedDescription': {
    speedThresholdText: string;
  };
  'HJM-M#groupModel&description': {
    groupOrder: number;
    groupType: number;
    groupName: string;
    groupSubName: string;
  };
}

interface GroupCheckboxInfo {
  enableCheck: number;
  activeCheck: number;
}

interface GroupAbstractInfo {
  groupId: number;
}

interface GroupCouponInfo {
  hasCoupon: boolean;
}

interface GroupDescriptionInfo {
  groupName: string;
  groupSubName: string;
  linkUrl: string;
  specialId: number;
}

interface GroupVendorInfo {
  vendorType: number;
  vendorId: number;
  vendorPrice: string;
}

interface GroupInfo {
  'HJM-M#groupModel&checkbox': GroupCheckboxInfo;
  'C-M#abstractGroupItem&core': GroupAbstractInfo;
  'HJM-M#groupModel&coupon': GroupCouponInfo;
  'HJM-M#groupModel&description': GroupDescriptionInfo;
  'HJM-M#groupModel&vendor': GroupVendorInfo;
}

export interface SubtotalDetailItemCoreInfo {
  [SUBTOTAL_DETAIL_ITEM_CORE_KEY]: {
    adjustType: string;
    price: string;
    subItemName: string;
    name: string;
    type: string;
    seq: number;
    priceColor: string;
    priceSize: number;
    priceWeight: string;
    imgUrl: string;
    showPriceTextG11N: string;
    // 免运费划线价
    showCrossPriceTextG11N?: string;
    crossPriceColor?: string;
    crossPriceWeight?: string;
    crossPriceSize?: number;
  };
}

export interface CouponDetailItemCoreInfo {
  'C-M#abstractCouponItem&CouponInfo': {
    notHaveCouponList: [];
  };
}

interface SubtotalNumberInfo {
  singleProductLimitNum: number;
  noneBookLimitNum: number;
  baiTiaoNoticeOn: number;
  preferentialSummary: {
    totalPrice: string;
  };
  baiTiaoSkuNum: number;
  selectedProductNum: string;
  bookLimitNum: number;
  productKindNum: number;
  productKindLimitNum: number;
  productNum: string;
  depreciateNum: string;
  selectedProductKindNum: number;
}

interface SubtotalOtherInfo {
  enableCheck: number;
  cartClearShow: boolean;
  configVersion: string;
  checkedCartState: number;
  activeCheck: number;
  imgDomain: string;
  cartAddClearGuide: number;
  settlementGroup: {
    [key: string]: number;
  };
  containGiftProduct?: boolean; // 1 代表购物车中包含赠品
}

interface SubtotalItemCoreInfo {
  totalPrice: string;
}

interface SubtotalPriceInfo {
  originTotalPriceShow: string;
  totalReprice: string;
  totalDiscount: string;
  originTotalPrice: string;
  priceShow: string;
  totalRealPrice: string;
  totalSavePrice: string;
  zeroOrderMsgG11N: string; // 0元单文案
  isZeroOrder: string; // 是否0元单 1：0元单
}

export interface SubtotalInfo {
  'HJM-D#subtotal&number': SubtotalNumberInfo;
  'HJM-D#subtotal&other': SubtotalOtherInfo;
  'C-M#subtotalItem&core': SubtotalItemCoreInfo;
  'HJM-D#subtotal&price': SubtotalPriceInfo;
}

interface OfficialDocExtInfo {
  doc: string;
  title: string;
}

export interface PartList {
  type: {
    namespace: string;
    version: string;
  };
  info: {
    [key: string]: {
      mfmzFullRefundType: number;
      promoType: string;
      activeCheck: number;
      id: string;
      title: string;
    };
  };
}
export interface SubtotalDetailItem {
  type: CartType;
  uuid: string;
  info: SubtotalDetailItemCoreInfo;
}

interface Data {
  [key: string]:
    | { type: CartType; uuid: string; info: TabMenuItemInfo }
    | {
        type: CartType;
        uuid: string;
        info: ProductItemInfo;
        partList?: PartList[];
      }
    | { type: CartType; uuid: string; info: FreightBasicInfo }
    | { type: CartType; uuid: string; info: GroupInfo }
    | SubtotalDetailItem
    | { type: CartType; uuid: string; info: SubtotalInfo }
    | { type: CartType; uuid: string; info: OfficialDocExtInfo }
    | { type: CartType; uuid: string; info: AddCartStatusInfo }
    | { type: CartType; uuid: string; info: CouponDetailItemCoreInfo }
    | { imageDomain: string }
    | { type: CartType; uuid: string; info: GiftFloorItemInfo } // 赠品聚合楼层信息
    | { type: CartType; uuid: string; info: GiftDrawerInfo }; // 顶部赠品楼层信息
}

interface Hierarchy {
  [key: string]: string[];
}

export interface LocalInfo {
  currency: string;
  currencySymbol: string;
  languageCode: string;
  timezoneId: string;
  currencyCode: string;
  currencyName: string;
  timeZoneId: string;
}

export interface CartData {
  data: Data;
  hierarchy: Hierarchy;
  resultCode?: string;
  code?: string;
  localInfo: LocalInfo;
  msg?: string;
}
// ----- response end ---------

// ----- select type response start ---------
interface PriceViewItemPriceInfo {
  memberPromotion?: boolean; // 是否会员价
  mainPrice: string;
  crossOffPrice: string;
  percentReductionDescIntergation: string;
  percentReduction: string;
  pricePlusTips: string;
}

interface SlashBottomBasic {
  cykj: string;
}

interface ViewCommonItemCommonCore {
  stockState: number;
  venderId: string;
  skuStatus: string;
  spuId: string;
  availableNum: number;
  skuId: string;
  disableUpdateButton?: boolean; //如果是活动商品，且是新人、预售等 如果为true则不能点击
}

interface ViewCommonItemCommonBasicProperty {
  delivery: string;
  pay_first: string;
  warranty: any;
  model: any;
  kjsp: any;
  sfhVAT: string;
}

interface ViewCommonItemCommonBasic {
  isXnzt: boolean;
  noSingleBuy: boolean;
  cartIcon: string;
  customerServiceGoUrl: string;
  shopText: string;
  property: ViewCommonItemCommonBasicProperty;
  isCanUsePoint: boolean;
  shopIcon: string;
  customerServiceIcon: string;
  isLoc: boolean;
  customerServiceText: string;
  cartText: string;
}

interface ViewSelectedItemCore {
  mainPrice: string;
  crossOffPrice: string;
  imageUrl: string;
  salesDesc: string;
}

export interface DimensionButton {
  // imgUrl: string;
  // stockState: number;
  // skuList: string[];
  // serialNumber: number;
  text: string;
  parentTitle?: string;
  key: string;
  label: string;
  serialNumber?: number;
  stockState?: number;
  hasStock?: boolean;
  imgUrl?: string;
  skuList: string[];
  checked?: boolean;
  // 是否禁用
  disabled?: boolean;
}
interface Dimension {
  dimensionNumber: number;
  dimTitle: string;
}

export interface DimensionButtonObject {
  'C-P#dimensionButton&dimensionButton': DimensionButton;
}
export interface ColorSizePart {
  buttonPartList: DimensionButtonObject[];
  'C-P#dimension&dimension': Dimension;
}
export interface TypeDetailInfo {
  priceModule?: {
    [VIEW_SEL_ITEM_PRICE_INFO]: PriceViewItemPriceInfo;
  };
  commonModule?: {
    'VCYBB2C-D#slashBottom&basic': SlashBottomBasic;
    'C-M#viewCommonItem&commonCore': ViewCommonItemCommonCore;
    'C-M#viewCommonItem&commonBasic': ViewCommonItemCommonBasic;
  };
  selectedModule?: {
    [VIEW_SEL_ITEM_KEY]: ViewSelectedItemCore;
    colorSizePartList: ColorSizePart[];
    skuStatus: Record<string, string>;
  };
  masterMapModule?: any;
  seriesModule?: { series: any[] };
  localInfo?: LocalInfo;
  serviceModule?: ServiceFloorData;
}

export interface TypeInfo {
  resultInfo: TypeDetailInfo;
  systemInfo: SystemInfo;
}
export interface SystemInfo {
  userAgentId: number;
  businessUnitId: any;
  callerAppName: null | string;
  callerDataCenter: null | string;
  callerIP: null | string;
  sdkVersion: null | string;
  language: null | string;
  businessType: null | string;
  buId: string;
  countryCode: string;
  languageCode: string;
  currencyCode: string;
  timezoneOffset: null | number;
  flowField: any;
  traceId: string;
}
export enum GiftDrawerEntryType {
  LIST_TOP_FLOOR = 'LIST_TOP_FLOOR', // 商品列表顶部楼层入口
  LIST_PRODUCT_GIFT = 'LIST_PRODUCT_GIFT', // 商品列表商卡入口
  GIFT_FAILED = 'GIFT_FAILED',
}

// ----- select type response end ---------
